<template>
  <calculator />
</template>

<script>
import Calculator from '@/views/assignor/components/Calculator.vue'

export default {
  name: 'CalculatorPage',
  components: {
    Calculator,
  },
}
</script>
